import { useEffect, useState } from "react";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { PublicKey } from "@solana/web3.js";
import {
  claimNft,
  fetchFarm,
  fetchFarmer,
  getNFTsByOwner,
  // initGemFarm,
  populateVaultNFTs,
  stakeNft,
  unstakeNft,
} from "helpers/functions";
import { SignerWalletAdapter } from "@solana/wallet-adapter-base";
import styled from "styled-components";
import Loading from "react-loading-spinkit";
import VaultItem from "components/VaultItem";
// import dayjs from "dayjs";
// import toast from 'react-hot-toast';

import Logo from "../images/logo.png";
import dayjs from "dayjs";
import {
  ASSOCIATED_TOKEN_PROGRAM_ID,
  Token,
  TOKEN_PROGRAM_ID,
} from "@solana/spl-token";
// import dayjs from "dayjs";

const Home = ({ loading, setLoading }) => {
  const { connection } = useConnection();
  const { wallet, publicKey, sendTransaction } = useWallet();

  const [rewardValue, setRewardValue] = useState(0);

  const [farm, setFarm] = useState(null);
  const [farmer, setFarmer] = useState(null);

  const [stakedNfts, setStakedNfts] = useState(null);
  const [unstakedNfts, setUnstakedNfts] = useState(null);

  // reset farmer on wallet change
  useEffect(() => {
    if (wallet && !publicKey) {
      setFarmer(null);
    }
  }, [publicKey, wallet]);

  useEffect(() => {
    async function fetchFarmFunc() {
      // grab farm on load
      if (connection) {
        const farm = await fetchFarm(connection, undefined);
        setFarm(farm);
      }

      if (publicKey!) {
        // if wallet is connected grab farmer on load
        const farmer = await fetchFarmer(
          connection,
          wallet.adapter as SignerWalletAdapter,
          publicKey
        );
        setFarmer(farmer);
      }
    }

    fetchFarmFunc();
  }, [connection, publicKey, wallet]);

  useEffect(() => {
    if (farmer) {
      const interval = setInterval(() => getEstReward(), 1000);

      return () => {
        clearInterval(interval);
      };
    }
  });

  const getEstReward = () => {
    // without decimal
    const earningsPerDay = 100;

    // last time farmer refreshed - timestamp
    const lastUpdatedTs = dayjs(
      new Date(
        farmer.farmerAcc.rewardA.fixedRate.lastUpdatedTs.toNumber() * 1000
      )
    );
    // earning per day
    const now = dayjs();
    const diffInSec = now.diff(lastUpdatedTs, "seconds");
    const diffInCoins = diffInSec * (earningsPerDay / 86400);

    const rewards =
      (farmer?.farmerAcc.rewardA.accruedReward.toNumber() -
        farmer?.farmerAcc.rewardA.paidOutReward.toNumber()) /
        Math.pow(10, 9) +
        diffInCoins ?? 0;

    setRewardValue(rewards * Number(farmer?.farmerAcc?.gemsStaked));
  };

  useEffect(() => {
    if (publicKey!) {
      refreshAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicKey]);

  async function refreshAll() {
    await getUnstakedNfts();
    await getStakedNfts();
    setLoading(false);
  }

  async function getStakedNfts() {
    const vaultNfts = await populateVaultNFTs(
      connection,
      wallet!.adapter as SignerWalletAdapter,
      publicKey
    );
    await setStakedNfts(vaultNfts);
  }

  async function getUnstakedNfts() {
    const walletNfts = await getNFTsByOwner(connection, publicKey);
    await setUnstakedNfts(walletNfts);
  }

  const claim = () => {
    claimNft(connection, wallet, publicKey, sendTransaction);
  };

  const stakeAction = async (nft) => {
    setLoading(true);
    const creator = new PublicKey(nft.data.creators[0].address);

    const associatedAddress = await Token.getAssociatedTokenAddress(
      ASSOCIATED_TOKEN_PROGRAM_ID,
      TOKEN_PROGRAM_ID,
      nft.mint,
      publicKey
    );

    await stakeNft(
      connection,
      wallet,
      nft.mint,
      associatedAddress,
      creator,
      publicKey,
      sendTransaction
    );

    await refreshAll();
    refreshAll();
  };

  const unstakeAction = async (nft) => {
    setLoading(true);
    await unstakeNft(
      connection,
      wallet,
      nft.mint,
      publicKey,
      sendTransaction,
      stakedNfts
    );

    await refreshAll();
    refreshAll();
  };

  // staked perc
  const percCalc = (farm?.gemsStaked?.toString() / 1111) * 100;
  const perc = percCalc.toFixed(2);

  if (!publicKey) {
    return (
      <PageWrapper>
        <PageContainer>
          <img
            src={Logo}
            alt={"Lil Degen Ape Club"}
            height={139}
            style={{
              display: "flex",
              margin: "0 auto 50px",
              textAlign: "center",
            }}
          />
          <IntroContainer>
            <IntroStatsContainer>
              <div />
              <div>
                <span>Total LDAC Staked</span>
                <h3>{farm?.gemsStaked?.toString() ?? 0}</h3>
              </div>
              <div>
                <span>% of LDAC Staked</span>
                <h3>{perc}%</h3>
              </div>
              <div />
            </IntroStatsContainer>
            <WalletMultiButton
              style={{
                background: "#fff",
                border: "1px solid #fff",
                color: "#7945FF",
              }}
            />
          </IntroContainer>
        </PageContainer>
      </PageWrapper>
    );
  } else {
    return (
      <>
        {loading && (
          <div
            style={{
              background: "rgba(39,39,39,0.75)",
              height: "100vh",
              position: "fixed",
              width: "100vw",
              bottom: 0,
              left: 0,
              right: 0,
              top: 0,
              zIndex: 10,
            }}
          >
            <Loading color={"#ffffff"} show={true} />
          </div>
        )}
        <PageWrapper>
          <PageContainer>
            <img
              src={Logo}
              alt={"Lil Degen Ape Club"}
              height={139}
              style={{
                display: "flex",
                margin: "0 auto 50px",
                textAlign: "center",
              }}
            />
            <IntroContainer>
              <IntroStatsContainer>
                <div>
                  <span>Your Wallet</span>
                  <h3>
                    {publicKey?.toString().slice(0, 4)}....
                    {publicKey
                      ?.toString()
                      .slice(
                        publicKey?.toString().length - 4,
                        publicKey?.toString().length
                      )}
                  </h3>
                </div>
                <div>
                  <span>Lil Degen Apes Staked</span>
                  <h3>{farmer?.farmerAcc?.gemsStaked?.toString() ?? 0}</h3>
                </div>
                <div>
                  <span>Est. Earnings ($GEMZ)</span>
                  <h3>{rewardValue.toFixed(3)}</h3>
                </div>
                <div>
                  <span>Reward Rate ($GEMZ)</span>
                  <h3>
                    {stakedNfts?.length > 0 ? stakedNfts?.length * 100 : 100} /
                    day
                  </h3>
                </div>
              </IntroStatsContainer>
              <StakingButtonsContainer>
                <button onClick={() => claim()} disabled={!farmer}>
                  Claim $GEMZ
                </button>
              </StakingButtonsContainer>
              <VaultsContainer>
                {unstakedNfts && (
                  <VaultWrapper>
                    <h2>Unstaked</h2>
                    <VaultContainer>
                      {unstakedNfts?.map((nft) => (
                        <VaultItem
                          key={nft?.mint?.toString()}
                          nft={nft}
                          type={"unstaked"}
                          action={() => stakeAction(nft)}
                        />
                      ))}
                    </VaultContainer>
                  </VaultWrapper>
                )}
                {stakedNfts && (
                  <VaultWrapper>
                    <h2>Staked</h2>
                    <VaultContainer>
                      {stakedNfts?.map((nft) => {
                        return (
                          <VaultItem
                            key={nft?.mint?.toString()}
                            nft={nft}
                            type={"staked"}
                            action={() => unstakeAction(nft)}
                          />
                        );
                      })}
                    </VaultContainer>
                  </VaultWrapper>
                )}
              </VaultsContainer>
            </IntroContainer>
          </PageContainer>
        </PageWrapper>
      </>
    );
  }
};

export default Home;

const PageWrapper = styled.div`
  margin-bottom: auto;
`;
const PageContainer = styled.div`
  padding: 40px;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

const IntroContainer = styled.div`
  text-align: center;
  width: 100%;

  button {
    display: inline-flex;
  }
`;

const IntroStatsContainer = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;
  margin: 0 auto 50px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);

    div {
      &:first-child {
        display: none;
      }

      &:last-child {
        display: none;
      }
    }
  }

  span {
    margin-bottom: 8px;
  }

  h3 {
    font-size: 32px;
    font-weight: 700;
    line-height: 1;
    margin: 0;
  }
`;

const VaultsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  /* justify-content: center; */
  /* margin: 0 auto; */

  @media only screen and (min-width: 768px) {
    display: grid;
    grid-gap: 8px;
    grid-template-columns: repeat(2, 1fr);
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 20px;
  }
`;

const VaultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  h2 {
    text-align: left;
  }

  @media only screen and (max-width: 768px) {
    &:first-child {
      order: 1;
    }

    &:last-child {
      order: 0;
    }
  }
`;

const VaultContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StakingButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px auto;

  button {
    margin-left: 8px;
    margin-right: 8px;

    @media only screen and (max-width: 768px) {
      font-size: 14px;
    }
  }
`;
